module.exports = __webpack_public_path__ + "static/img/plan1.de0a959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/plan1.png
// module id = 7h0V
// module chunks = 35